import React from "react";
import PropTypes from "prop-types";
import Style from "./modal.module.scss";
import { alertActions, customerTab, pricingPlan } from "../../locales/en";
import CommonModal from "./CommonModal";

const CountryinfoModal = ({ isOpen, toggle, countryInformation }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName={`${Style.xeroModal} modal-dialog-centered`}
      bodyClassName={`${Style.aiScModalContent} modal-content`}
      footerClassName={Style.aiScModalFooter}
      hideHeader
      footerButtons={[
        {
          label: alertActions.ok,
          className: "btn btn-primary",
          onClick: toggle
        }
      ]}
    >
      <h2 className="text-center">{customerTab?.details.countryInfo.title}</h2>
      <p>
        {pricingPlan?.bulkChange.country}
        <span>{countryInformation.primaryCountry}</span>
        <br />
        {customerTab?.details.countryInfo.accCountry}
        <span>{countryInformation.accountingCountry}</span>
        <br />
        {customerTab?.details.countryInfo.websiteEntry}
        <span>{countryInformation.originCountry}</span>
      </p>
    </CommonModal>
  );
};

CountryinfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  countryInformation: PropTypes.shape({
    primaryCountry: PropTypes.string,
    accountingCountry: PropTypes.string,
    originCountry: PropTypes.string
  }).isRequired
};

export default CountryinfoModal;
